<div class="input-decimal" (click)="onTouched()" *ngIf="material">
  <mat-form-field appearance="outline">
    <mat-label> {{placeholder}} </mat-label>
    <input matInput #input [placeholder]="placeholder" [readonly]="readonly" (input)="onInputChange()" />
  </mat-form-field>
</div>

<div class="input-decimal" (click)="onTouched()" *ngIf="!material">
  <input #input class="item-price-input text-right" [placeholder]="placeholder" [readonly]="readonly"
    (input)="onInputChange()" />
</div>